module.exports = __webpack_public_path__ + "static/img/1.62240a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/1.png
// module id = o6TA
// module chunks = 0